export const tr = {
  subtitle: 'Günün ülkesini tahmin et',
  modes: { classic: 'Klasik', flag: 'Bayrak', outline: 'Siluet', connections: 'Bağlantılar', trivia: 'Bilgi Yarışması', draw: 'Çizim' },
  recommendations: {
    title: 'Bunları da beğenebilirsiniz',
    open: '{name} sitesini aç',
    games: {
      wormillion: 'Nadir yanıtlarla günlük coğrafya oyunu',
      stardewdle: 'Günlük Stardew Valley bulmacaları',
      cascadle: 'Günlük çağlayan kelime oyunu',
      farhike: 'Az seçilen ülkelerle günlük harita bulmacası',
    },
  },
  draw: {
    subtitle: 'Ülkenin dış hatlarını hafızandan çiz',
    askLabel: 'Bu ülkeyi çiz',
    drawingLabel: 'Çizim',
    askHint: 'Hafızandan — referans yok, tek deneme.',
    blank: 'boş bir sayfa — üzerinden geçmek yok',
    canvasLabel: 'Çizim alanı',
    start: 'Çizmeye başla',
    undo: 'Geri al',
    clear: 'Temizle',
    done: 'Bitir',
    next: 'Sonraki ülke',
    score: 'Puan',
    accuracy: 'Doğruluk',
    coverage: 'Kapsama',
    deviation: 'Sapma',
    legendTrue: 'Gerçek dış hat',
    legendYours: 'Senin çizgin',
    legendOut: 'Fazla dışarıda',
    legendIn: 'Fazla içeride',
    pts: 'puan',
    learnMore: 'Daha fazla bilgi',
    ranks: [
      'Saray Kartografı',
      'Usta Kartograf',
      'Usta Haritacı',
      'Kararlı El',
      'Çırak',
      'Kaba Taslak',
      'Atlasa Geri Dön',
    ],
  },
  trivia: {
    subtitle: 'Her gün on coğrafya sorusu',
    loading: 'Bugünün soruları yükleniyor…',
    question: 'Soru',
    correct: 'Doğru!',
    wrong: 'Tam değil',
    next: 'Sonraki soru',
    seeResult: 'Sonucu gör',
    xpNote: 'Her doğru cevap 3 XP, on doğruya +10 bonus.',
    comeBack: 'Yeni on soru UTC gece yarısında gelir.',
    tiers: ['Kusursuz — 10’da 10!', 'Çok iyi — tebrikler.', 'Fena değil. Yarın yine dene.', 'Zor bir turdu. Dünya büyük.'],
  },
  conn: {
    subtitle: '16 ülkeyi 4 gruba ayır',
    oneAway: 'Bir tanesi yanlış…',
    shuffle: 'Karıştır',
    deselect: 'Seçimi kaldır',
    submit: 'Gönder',
    mistakes: 'Hatalar',
    solved: 'Çözüldü!',
    lost: 'Bir dahaki sefere!',
    nextPuzzle: 'Sonraki bulmaca',
    flawless: 'Kusursuz — hiç hata yok!',
    wellPlayed: 'Grupları iyi ayırdın.',
    lostSub: 'Dört grup yukarıda gösterildi.',
    guesses: 'Deneme',
  },
  soon: 'yakında',
  streak: 'Seri',
  today: 'Bugün',
  yesterday: 'Dün',
  nextIn: 'Sonraki ülkeye kalan',
  daily: 'Günlük',
  unlimited: 'Sınırsız',
  nextCountry: 'Sonraki ülke',
  skip: 'Geç',
  solved: 'Çözüldü',
  best: 'En iyi',
  emptyHint: 'İpuçlarını görmek için ilk tahminini yap.',
  boardScrollLabel: 'Tahmin karşılaştırma tablosu. Tüm ipuçlarını görmek için yatay kaydırın.',
  legend: { correct: 'Eşleşme', incorrect: 'Eşleşmiyor', numbers: 'cevap ↑ daha yüksek · ↓ daha düşük', distance: 'yakın → uzak' },
  placeholder: 'Bir ülke yaz…',
  guess: 'Tahmin et',
  won: 'Çözüldü!',
  lost: 'Tahmin hakkın bitti',
  answerWas: 'Aranan ülke',
  answerCard: { viewProfile: 'Ülke profilini gör', northernHemisphere: 'Kuzey Yarımküre', southernHemisphere: 'Güney Yarımküre' },
  share: 'Paylaş',
  copyLink: 'Bağlantıyı kopyala',
  copyResult: 'Sonucu kopyala',
  copyEmbed: 'Yerleştirme kodunu kopyala',
  saveImage: 'Görseli kaydet',
  shareToday: 'Bugünü paylaş',
  copied: 'Kopyalandı!',
  cols: { region: 'Bölge', pop: 'Nüfus', area: 'Alan', borders: 'Sınır', gdp: 'GSYİH', temp: 'Sıc.', dist: 'Mesafe' },
  colTips: {
    region: 'Ülkenin bulunduğu kıta. Yeşil, cevabın da aynı kıtada olduğunu gösterir.',
    dist: 'Tahminin ile cevap arasındaki kuş uçuşu mesafe. Kırmızı uzak, yeşil yakındır; ok cevabın yönünü gösterir.',
    borders: 'Kara sınırını paylaştığı ülke sayısı. ↑, cevabın daha fazla sınırı olduğunu gösterir.',
    temp: 'Başkent değil, ülke yüzölçümünün tamamı üzerinden hesaplanan 1991–2020 yıllık sıcaklık ortalaması.',
    pop: 'Toplam nüfus. ↑, cevabın nüfusunun daha fazla olduğunu gösterir.',
    area: 'Km² cinsinden kara alanı. ↑, cevabın daha büyük olduğunu gösterir.',
    gdp: 'ABD doları cinsinden kişi başına GSYİH. ↑, cevapta kişi başına gelirin daha yüksek olduğunu gösterir.',
  },
  puzzle: {
    flag: 'Bu bayrak hangi ülkeye ait?',
    outline: 'Bu şekil hangi ülkeye ait?',
  },
  account: {
    signIn: 'Giriş yap',
    withGoogle: 'Google ile devam et',
    withDiscord: 'Discord ile devam et',
    tagline: 'Serini tüm cihazlarında koru',
    signOut: 'Çıkış yap',
    level: 'Sv.',
    viewProfile: 'Profili gör',
    editProfile: 'Profili düzenle',
  },
  settings: {
    title: 'Profili Düzenle',
    avatar: 'Profil resmi',
    change: 'Değiştir',
    displayName: 'Görünen ad',
    bio: 'Hakkında',
    bioPh: 'Diğer kâşiflere kendinden bahset…',
    birthday: 'Doğum günü',
    country: 'Ülke',
    countryNone: 'Belirtilmedi',
    gender: 'Cinsiyet',
    genders: { male: 'Erkek', female: 'Kadın', other: 'Diğer', na: 'Belirtmek istemiyorum' },
    socials: 'Sosyal bağlantılar',
    invalidUrl: 'Bu platform için geçerli bir URL girin.',
    date: { year: 'Yıl', month: 'Ay', day: 'Gün' },
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    saved: 'Kaydedildi',
    signInRequired: 'Profilini düzenlemek için giriş yap.',
    cropTitle: 'Profil resmini kırp',
    cropHint: 'Konumlandırmak için sürükle · yakınlaştırmak için kaydır',
    apply: 'Uygula',
    cancel: 'İptal',
    pick: 'Görsel seç',
    uploadError: 'Yükleme başarısız — daha küçük bir görsel deneyin.',
  },
  netError: 'Bağlantıda bir sorun oldu — yeniden deneyin.',
  offlinePractice: 'Çevrimdışı alıştırma — sıralamaya girmez.',
  xp: 'XP',
  levelUp: 'Seviye atladın!',
  honors: {
    title: 'Rozetler ve Madalyalar',
    intro: 'Tamamladığın her bulmaca üç şekilde kaydedilir: taşıdığın rütbe, kazandığın madalya ve koruduğun rozet.',
    levelT: 'Seviye rozetleri',
    levelD: 'Günlük oyundan kazandığın XP, gezgin asasından okyanusları aşan amiral gemisine uzanan yolculuğun 14 işlemeli nişanında ilerlemeni sağlar.',
    dailyT: 'Günlük madalyalar',
    dailyD: 'Bugün tablosu, kâşifleri önce tamamladıkları altı modun sayısına, ardından kullandıkları tahmin sayısının azlığına göre sıralar. İlk üç altın, gümüş ve bronz kazanır; bunlar profilinde kalıcı olarak sayılır.',
    boardT: 'Sıralama rozetleri',
    boardD: 'Seri, Sınırsız veya Seviye tablosunda ilk üçte kaldığın her gün rozete işlenir. Altın, gümüş ve bronz günler ayrı ayrı sayılır.',
    cta: 'Liderlik tablosunu gör',
  },
  lb: {
    scoreBreakdown: 'Puan ayrıntısı',
    scoreAvg: 'Ortalama',
    scoreNote: 'Önce tamamlanan mod sayısına, sonra bu ortalamaya göre sıralanır.',
    title: 'Liderlik Tablosu',
    today: 'Bugün',
    streak: 'Seri',
    level: 'Seviye',
    unlimited: 'Sınırsız',
    connections: 'Bağlantılar',
    myRank: 'Sıralaman',
    empty: 'Henüz kayıt yok — ilk sen ol.',
    signInToRank: 'Liderlik tablosunda görünmek için giriş yap.',
    guesses: 'tahmin',
    guess1: 'tahmin',
    totalSolved: 'Çözülen',
    yourStats: 'İstatistiklerin',
    back: 'Oyuna dön',
    nav: 'Liderlik tablosu',
    viewAll: 'Tümünü gör',
    dailyMedals: 'Günlük madalyalar',
    heldBadges: 'Sıralama rozetleri',
    notFound: 'Kâşif bulunamadı.',
  },
  privacy: {
    title: 'Gizlilik Politikası',
    updated: 'Son güncelleme: 28 Haziran 2026',
    sections: [
      {
        h: 'Biz kimiz',
        p: ['GeoDle (“biz”), geodle.org adresinde sunulan ücretsiz bir günlük coğrafya tahmin oyunudur.'],
      },
      {
        h: 'Topladığımız veriler',
        p: [
          'Oyun verileri: tahminleriniz, günlük ilerlemeniz, seriniz ve deneyim puanlarınız — oyunu çalıştırmak ve cihazlarınız arasında eşitlemek için saklanır.',
          'Hesap verileri (yalnızca Google veya Discord ile giriş yaparsanız): benzersiz hesap kimliğiniz, görünen adınız ve profil resminiz. Parolanızı hiçbir zaman almayız.',
        ],
      },
      {
        h: 'Verilerinizi nasıl kullanıyoruz',
        p: [
          'İlerlemenizi kaydetmek ve eşitlemek, seri ve seviyeleri hesaplamak, giriş yapan oyuncuların herkese açık liderlik tablolarını ve profillerini göstermek için.',
          'Verilerinizi satmayız ve reklam amacıyla kullanmayız.',
        ],
      },
      {
        h: 'Analiz ve çerezler',
        p: [
          'Anonim ve toplu kullanım verilerini anlamak için Google Analytics ve Microsoft Clarity kullanıyoruz. Bu hizmetler kendi çerezlerini ayarlayabilir; bunları sizi kişisel olarak tanımlamak için kullanmayız.',
          'Oturumunuzu açık tutmak ve ilerlemenizi eşitlemek için bir adet birinci taraf çerezi kullanıyoruz.',
        ],
      },
      {
        h: 'Haklarınız ve silme',
        p: [
          'Aşağıdaki düğmeyi kullanarak hesabınızı ve ilişkili tüm verileri istediğiniz zaman kalıcı olarak silebilirsiniz. Silme işlemi hemen yürürlüğe girer.',
        ],
      },
      { h: 'İletişim', p: ['Verilerinizle ilgili sorularınız için contact@geodle.org adresine e-posta gönderin.'] },
    ],
    deleteAccount: 'Hesabımı ve verilerimi sil',
    deleteConfirm: 'Bu işlem hesabınızı ve tüm ilerlemenizi kalıcı olarak siler. Devam edilsin mi?',
    deleted: 'Hesabınız ve verileriniz silindi.',
  },
  terms: {
    title: 'Kullanım Koşulları',
    updated: 'Son güncelleme: 28 Haziran 2026',
    sections: [
      {
        h: 'Kabul',
        p: ['GeoDle’ı kullanarak bu koşulları kabul edersiniz. Kabul etmiyorsanız lütfen hizmeti kullanmayın.'],
      },
      {
        h: 'Hizmet',
        p: [
          'GeoDle, kişisel ve ticari olmayan eğlence amacıyla “olduğu gibi” sunulan ücretsiz bir günlük coğrafya tahmin oyunudur. Herhangi bir bölümünü istediğimiz zaman değiştirebilir, askıya alabilir veya sonlandırabiliriz.',
        ],
      },
      {
        h: 'Hesaplar ve adil oyun',
        p: [
          'Giriş yapmak isteğe bağlıdır; ilerlemenizi eşitlemek ve sizi liderlik tablolarında sıralamak için kullanılır. Hesabınızdaki etkinliklerden siz sorumlusunuz.',
          'Hile yapmayın, oyunu otomatikleştirmeyin; puanları, serileri veya liderlik tablolarını başka yollarla değiştirmeye çalışmayın. Bunu yapan kayıtları veya hesapları kaldırabiliriz.',
        ],
      },
      {
        h: 'Kabul edilebilir kullanım',
        p: [
          'Saldırgan, hak ihlali oluşturan veya yanıltıcı olmayan bir görünen ad ve profil resmi seçin. Bu kurala uymayan içerikleri veya hesapları kaldırabiliriz.',
        ],
      },
      {
        h: 'Fikri mülkiyet',
        p: [
          'Ülke verileri açık veri kümelerinden (mledoze/countries, Natural Earth) gelir. GeoDle bağımsız bir projedir ve herhangi bir hükûmet ya da kuruluşla bağlantılı değildir.',
        ],
      },
      {
        h: 'Sorumluluk reddi ve sınırı',
        p: [
          'Hizmet herhangi bir garanti olmaksızın sunulur. Yasaların izin verdiği ölçüde, GeoDle kullanımınızdan doğan zararlardan sorumlu değiliz.',
        ],
      },
      {
        h: 'Değişiklikler',
        p: ['Bu koşulları zaman zaman güncelleyebiliriz. Bir değişiklikten sonra kullanmaya devam etmeniz güncel koşulları kabul ettiğiniz anlamına gelir.'],
      },
      { h: 'İletişim', p: ['Sorularınız için contact@geodle.org adresine e-posta gönderin.'] },
    ],
  },
  country: {
    whereOnEarth: 'Dünyadaki konumu',
    atAGlance: 'Kısa bilgiler',
    howItCompares: 'Dünya ile karşılaştırma',
    neighbours: 'Komşular',
    inGeoDle: 'GeoDle: {name}',
    exploreNearby: 'Yakındaki ülkeleri keşfet',
    faqTitle: 'Sık Sorulan Sorular',
    metaTitle: '{name} — Başkent, Nüfus, Yüzölçümü ve Bilgiler | GeoDle',
    metaDesc: '{name}: başkent {capital}, nüfus {pop}, yüzölçümü {area} km². Dünyanın nüfus bakımından {rankPop} ülkesi; bölge: {region}. Bilgiler, harita, komşular ve daha fazlası.',
    getToKnow: 'Yakından tanıyın: {name}',
    k: { history: 'Tarihten dönüm noktaları', people: 'Tanınmış kişiler', landmarks: 'Görülecek yerler', culture: 'Kültür ve tatlar' },
    sources: 'Kaynaklar',
    listTitle: 'Ülkeler',
    listSearch: 'Ülke ara…',
    listAll: 'Tüm bölgeler',
    listCount: '{n} ülke',
    listEmpty: 'Aramanızla eşleşen ülke yok.',
    promoTitle: 'Tüm ülkeleri keşfet',
    promoDesc: 'Bayraklar, başkentler, nüfuslar ve etkileşimli küre — 194 ülkenin her biri için ayrıntılı sayfa.',
    promoCta: 'Ülkelere göz at',
    metaTitleList: 'Dünyadaki Tüm Ülkeler — Bayraklar, Başkentler ve Bilgiler | GeoDle',
    metaDescList: 'Tüm ülkeleri keşfedin: bayraklar, başkentler, nüfus, yüzölçümü ve daha fazlası. Bölgeye göre arayıp filtreleyin, dünyayı etkileşimli küre üzerinde inceleyin.',
    play: 'Oyna',
    guessFlag: 'Bayrağı tahmin et',
    guessOutline: 'Silueti tahmin et',
    back: 'GeoDle',
    notFound: 'Ülke bulunamadı.',
    landlocked: 'Denize kıyısı yok',
    coastal: 'Denize kıyısı var',
    north: 'Kuzey',
    south: 'Güney',
    landBorders: '{n} kara sınırı',
    landBorder: '1 kara sınırı',
    noBorders: '{name}: kara sınırı yoktur.',
    locLede: '{name} — konum: {subregion}, {region}.',
    locLandlocked: 'Denize kıyısı olmayan bir ülkedir.',
    locCoastal: 'Denize kıyısı vardır.',
    locBorders: '{n} ülkeyle kara sınırını paylaşır.',
    locBorder: 'Bir ülkeyle kara sınırını paylaşır.',
    locIsland: 'Ada ülkesi olduğu için kara sınırı yoktur.',
    f: { capital: 'Başkent', population: 'Nüfus', area: 'Yüzölçümü', region: 'Bölge', subregion: 'Alt bölge', coast: 'Kıyı', hemisphere: 'Yarımküre', iso: 'ISO', languages: 'Diller', currency: 'Para birimi', timezone: 'Saat dilimi', calling: 'Telefon kodu', driving: 'Trafik yönü', tld: 'Ülke alan adı', nativeName: 'Yerel ad' },
    s: {
      popWorld: 'dünya nüfus sıralaması ({total} ülke arasında).',
      popRegion: '{region} nüfus sıralaması ({total} ülke arasında).',
      areaLargest: 'yüzölçümü bakımından en büyük',
      biggerThan: '{x} ülkesinden daha büyük',
      smallerThan: '{x} ülkesinden daha küçük',
      perKm2: 'km² başına kişi',
      sparse: 'seyrek nüfuslu',
      moderate: 'orta yoğunlukta',
      dense: 'yoğun nüfuslu',
      morePeople: '{x} ülkesinden daha kalabalık',
      fewerPeople: '{x} ülkesinden daha az nüfuslu',
      vs: 'karşılaştırma',
      neighbours: 'kara komşusu',
      neighbour: 'kara komşusu',
    },
    q: {
      capitalQ: '{name}: başkent hangisi?',
      capitalA: '{name} — başkent: {capital}.',
      popQ: '{name}: nüfus ne kadar?',
      popA: '{name}: yaklaşık {pop} kişi yaşar; dünya nüfus sıralamasında {rank} sıradadır.',
      areaQ: '{name}: yüzölçümü ne kadar?',
      areaA: '{name}: yüzölçümü {area} km²; alan bakımından dünyada {rank} sıradadır.',
      regionQ: '{name}: hangi bölgede?',
      regionA: '{name} — konum: {subregion}, {region}.',
    },
  },
  footer:
    'Ülke verileri: mledoze/countries (ODbL) · Harita verileri: Natural Earth (kamu malı). GeoDle bağımsız bir projedir; herhangi bir hükûmet ya da kuruluşla bağlantılı değildir.',
};
